@if (summary.releaseData; as data) {
  <div [ngClass]="{'fieldset disabled' :
     (!appContext.isCommercialReleaseDeclarant() && !appContext.isCommercialReleaseEditor())
     || summary.releaseStatus?.status =='DECLARED' || appContext.isHinterlandTerminal()}">
    <div class="row">
      <div class="col-md">
        @if (summary.id && !!summary.releaseStatus?.status) {
          <app-form-group label="Id">
            <input required class="form-control" [ngModel]="summary.id" disabled>
          </app-form-group>
        }
        <app-form-group label="Consignment number">
          <app-search required [ngModel]="data.consignmentNumber" [minCharacters]="3"
                      [searchFunction]="refData.findAllConsignments"
                      resultFormatter="masterConsignment.consignmentNumber"
                      (ngModelChange)="selectConsignment($event)"
                      newValueFromInputFunction="masterConsignment.consignmentNumber"
                      [disabled]="!!summary.releaseStatus?.status">
          </app-search>
        </app-form-group>
        @if (data.consignmentNumber) {
          @if (selectedConsignment?.crn) {
            @if (data.consignmentNumber) {
              <app-form-group label="Container number">
                <app-select placeholder="– Select a container number –" [(ngModel)]="data.equipmentNumber" required
                            [addSelectedIfNotExists]="true"
                            [disabled]="!!summary.releaseStatus?.status"
                            [refreshWatch]="selectedConsignment"
                            [refreshProvider]="containersInConsignment"></app-select>
              </app-form-group>
            }
            <app-form-group label="Container operator">
              <app-select [(ngModel)]="data.containerOperator" [addSelectedIfNotExists]="true"
                          [refreshProvider]="carriersProvider" [refreshWatch]="selectedConsignment?.iamConnectedId
                    || data.containerOperator?.cargoDeclarantShortName" dataKey="smdgCode" required
                          [formatter]="refData.containerOperatorFormatter"
                          placeholder="– Select a container operator –">
              </app-select>
            </app-form-group>
            <app-form-group label="Terminal">
              <app-select disabled required [ngModel]="data.terminalShortName" [options]="terminals"
                          [formatter]="terminalOrganisationName"
                          [addSelectedIfNotExists]="true"></app-select>
            </app-form-group>
            <app-form-group label="CRN">
              <input class="form-control" [ngModel]="summary.crn" disabled>
            </app-form-group>
          } @else {
            <app-form-group label="Container number">
              <input class="form-control" [(ngModel)]="data.equipmentNumber"
                     required [disabled]="!!summary.releaseStatus?.status"
                     (change)="data.equipmentNumber=$event.target?.value?.toUpperCase()">
            </app-form-group>
            <app-form-group label="Container operator">
              <app-search [(ngModel)]="data.containerOperator" dataKey="name"
                          [searchFunction]="refData.findContainerOperators" required
                          [inputFormatter]="refData.containerOperatorFormatter"
                          [disabled]="!!summary.releaseStatus?.status"></app-search>
            </app-form-group>
            <app-form-group label="Terminal">
              <app-select required [(ngModel)]="data.terminalShortName" [options]="terminals"
                          [formatter]="terminalOrganisationName"
                          [addSelectedIfNotExists]="true" [disabled]="!!summary.releaseStatus?.status"></app-select>
            </app-form-group>
            <app-form-group label="CRN">
              <input class="form-control" [(ngModel)]="summary.crn" [disabled]="!!summary.releaseStatus?.status"
                     (change)="summary.crn=$event.target?.value?.toUpperCase()">
            </app-form-group>
          }
        }
      </div>
      <div class="col-md">
        <app-form-group label="Release-to party">
          <app-search required [(ngModel)]="data.releaseToParty" [minCharacters]="1"
                      [searchFunction]="findReleaseToParties" [inputFormatter]="refData.formatReleaseToParty"
                      [disabled]="!!summary.releaseStatus?.status"></app-search>
        </app-form-group>
        <app-form-group label="Inland operator">
          <app-search [(ngModel)]="data.inlandOperator" [minCharacters]="3"
                      [searchFunction]="refData.findInlandOperatorsByEanCode"
                      [inputFormatter]="refData.inlandOperatorFormatter"
                      [disabled]="!!summary.releaseStatus?.status">
            (ngModelChange)="data.inlandOperator = $event" placeholder="Search by EAN code"
            [resultFormatter]="refData.inlandOperatorFormatter">
          </app-search>
        </app-form-group>
        <app-form-group label="Release deadline">
          <app-date-field [defaultTime]="'12:00'" [(ngModel)]="data.releaseDeadline"></app-date-field>
        </app-form-group>
        <app-form-group label="Release modality">
          <app-select placeholder="No preference" [nullOption]="true" [options]="['barge', 'road', 'rail']"
                      [(ngModel)]="data.releaseModality"></app-select>
        </app-form-group>
        <app-form-group label="Remarks">
          <textarea class="form-control" [(ngModel)]="data.remarks"></textarea>
        </app-form-group>
        <app-form-group>
          <label for="vesselInspectionRequired">Empty</label>
          <app-yes-no [(ngModel)]="summary.releaseData.empty" required></app-yes-no>
        </app-form-group>
      </div>
    </div>
  </div>
}
